import { createAction } from 'redux-actions';

import SwaggerAPI from 'data/SwaggerAPI';

const REQUEST_SENSORS = 'sensors/REQUEST_SENSORS';
const RECEIVE_SENSORS = 'properties/RECEIVE_SENSORS';

const initialState = {
  isFetchingSensors: false,
  sensors: [],
  initialized: false,
  orgStart: 0,
  orgEnd: 1,
  pageSize: 100,
  error: undefined,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_SENSORS: {
      return { ...state, initialized: true, isFetchingSensors: true };
    }
    case RECEIVE_SENSORS: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          isFetchingSensors: false,
          error: action.payload,
        };
      }

      return {
        ...state,
        isFetchingSensors: false,
        sensors: action.payload,
        error: undefined,
      };
    }
    default:
      return state;
  }
};

const Sensors = (function () {
  const startFetch = () => ({ type: REQUEST_SENSORS });
  const fetchSensors = createAction(RECEIVE_SENSORS, SwaggerAPI.sensorsList);

  const getIsFetching = (state) => state.properties.isFetchingSensors;
  const getIsFetchingSensors = (state) => state.properties.isFetchingSensors;

  const getSensors = (state) => state.sensors.sensors;
  const getError = (state) => state.sensors.error;
  const getSensorsPage = (state) => ({
    sensors: state.sensors.sensors,
    start: state.sensors.start,
    end: state.sensors.end,
  });

  return {
    startFetch,
    fetchSensors,

    getIsFetching,
    getIsFetchingSensors,
    getSensors,
    getSensorsPage,
    getError,
  };
})();

export default Sensors;
